function parseObjectToArray (viewMap, filterArray, object) {
  // object = removeParseDefaults(object.toJSON())
  let finalArray = new Array(Object.keys(viewMap).length)
  Object.keys(object).forEach((key) => {
    finalArray[viewMap[key]] = object[key]
    if (object[key] !== undefined && object[key].length > 0 && filterArray !== undefined && filterArray.indexOf(key) > -1) {
      finalArray[key] = object[key]
    }
  })
  return finalArray
}

export function uploadedOffersResponseHelper (responseArray, viewMap, filterArray) {
  return responseArray.map(parseObjectToArray.bind(null, viewMap, filterArray))
}

function removeParseDefaults (object) {
  if (object) {
    delete object.createdAt
    delete object.updatedAt
    delete object.objectId
    delete object.user
  }
  return object
}

export function objectMapper (jsonArray, viewMap) {
  let arrayOfObjects = []
  jsonArray.forEach((data) => {
    // data = data.toJSON()
    removeParseDefaults(data)
    let replacedKeyObject = Object.assign({}, ...Object.keys(data).map(
          key => {
            let mappedKey = getViewMapKey(key, viewMap)
            if (mappedKey) {
              return {
                [mappedKey]: (data[key] === undefined || data[key].length === 0) ? '' : data[key]
              }
            }
          }
        )
      )
    arrayOfObjects.push(replacedKeyObject)
  })
  return arrayOfObjects
}

export function serverJsonToViewJson (serverJson, viewJson) {
  let replacedKeyObject = Object.assign({}, ...Object.keys(serverJson).map(
        key => {
          let mappedKey = getViewMapKey(key, viewJson)
          if (mappedKey) {
            return {
              [mappedKey]: (serverJson[key] === undefined || serverJson[key].length === 0) ? '' : serverJson[key]
            }
          }
        }
      )
    )
  return replacedKeyObject
}

function getViewMapKey (inputKey, viewMap) {
  return viewMap[inputKey]
}



// WEBPACK FOOTER //
// ./src/components/shared/helper/ServerOjectToViewObject.js